import {useQuery} from '@apollo/react-hooks';

import {StatsBlockVertical} from 'shells/metrics/stats-block-vertical';

import type {
    GetAudienceMembershipStats as GetAudienceMembershipStatsQuery,
    GetAudienceMembershipStatsVariables as GetAudienceMembershipStatsQueryVariables,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_MEMBERSHIP_STATS from '../graphql/queries/get-audience-membership-stats.graphql';

import styles from './audience-membership-stats.module.css';

type Props = {
    audienceId: string;
    onClickStat?: (filterKey: string) => string;
};

export function AudienceMembershipStats(props: Props) {
    const {data, loading: isLoading} = useQuery<
        GetAudienceMembershipStatsQuery,
        GetAudienceMembershipStatsQueryVariables
    >(GET_AUDIENCE_MEMBERSHIP_STATS, {
        variables: {audienceId: props.audienceId},
    });

    return (
        <div className={styles['audience-membership-stats']}>
            <StatsBlockVertical
                stats={[
                    {
                        key: '1',
                        // @ts-expect-error
                        isLoading: isLoading,
                        title: 'Subscribers',
                        value:
                            data && data.audience
                                ? data.audience.membershipStats.subscribedCount.toLocaleString()
                                : null,
                        tooltip: 'People with a valid email address that can receive your messages',
                        clickingNavigatesTo: props.onClickStat
                            ? props.onClickStat('subscribedAudiences')
                            : undefined,
                    },
                    {
                        key: '2',
                        // @ts-expect-error
                        isLoading: isLoading,
                        title: 'Unsubscribed',
                        value:
                            data && data.audience
                                ? data.audience.membershipStats.unsubscribedCount.toLocaleString()
                                : null,
                        tooltip:
                            'People who have unsubscribed from the current audience or from all outreach',
                        clickingNavigatesTo: props.onClickStat
                            ? props.onClickStat('unsubscribedAudiences')
                            : undefined,
                    },
                    {
                        key: '3',
                        // @ts-expect-error
                        isLoading: isLoading,
                        title: 'Undeliverable',
                        value:
                            data && data.audience
                                ? data.audience.membershipStats.undeliverableCount.toLocaleString()
                                : null,
                        tooltip:
                            'Includes people without a valid email address, duplicated email addresses, and email addresses that have bounced',
                    },
                    {
                        key: '4',
                        // @ts-expect-error
                        isLoading: isLoading,
                        title: 'Total members',
                        value:
                            data && data.audience
                                ? data.audience.membershipStats.totalCount.value.toLocaleString()
                                : null,
                        tooltip:
                            'All members of the audience, including subscribers, unsubscribed, and undeliverable contacts',
                        clickingNavigatesTo: props.onClickStat
                            ? props.onClickStat('audiences')
                            : undefined,
                    },
                ]}
            />
        </div>
    );
}
